<audio
  #audio
  [hidden]="true"
  [src]="this.src"
  [controls]="true"
  [autoplay]="autoplay"
></audio>

<div class="player" (click)="$event.stopPropagation()">
  <div class="title">
    {{ title }}
  </div>

  <div class="controls">
    <div class="blank"></div>

    <div class="buttons">
      <app-button [btnType]="'icon'" (onChangeClick)="onRewind(false)">
        <app-icon class="player-controls-color">replay_5</app-icon>
      </app-button>

      <app-button [btnType]="'icon'" (click)="togglePlay()">
        <app-icon class="player-controls-color">{{
          this.isPlay ? 'pause' : 'play_arrow'
        }}</app-icon>
      </app-button>

      <app-button [btnType]="'icon'" (onChangeClick)="onRewind(true)">
        <app-icon class="player-controls-color">forward_5</app-icon>
      </app-button>
    </div>

    <div class="volume-control px-2">
      <app-icon (click)="onValueMute()">{{ volumeIcon }}</app-icon>
      <input
        #volume
        type="range"
        min="0"
        max="1"
        step="0.01"
        class="range"
        (input)="onVolumeChange($event)"
      />
    </div>
  </div>

  <div class="custom-width p-2" class="progress-wrapper">
    <div>
      <div class="progress-bar-audio player-progress-color">
        <div #progressBar class="progress-audio"></div>
      </div>
      <div class="progress-container">
        <div class="progress-bar-container">
          <div class="progress-bar" [style.width.%]="progress"></div>
        </div>
        <input
          class="progress-slider"
          type="range"
          id="progress-slider"
          min="0"
          max="100"
          step="0.01"
          [value]="progress"
          (input)="updateProgress($event)"
          (change)="setProgress($event)"
        />
      </div>
    </div>

    <div class="time">
      <span #currentTime class="text-dark user-select-none">00:00</span>
      <span #duration class="text-dark user-select-none">--:--</span>
    </div>
  </div>
</div>
